if (!customElements.get('product-submit-price')) {
  class ProductSubmitPrice extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.onQuantityChange = this.render.bind(this);
      this.bindQuantityInput();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          this.bindQuantityInput();
          this.render();
        });
      }

      this.render();
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      this.unbindQuantityInput();
    }

    bindQuantityInput() {
      const input = this.dataset.quantityInput ? document.getElementById(this.dataset.quantityInput) : null;
      if (input === this.quantityInput) return;

      this.unbindQuantityInput();
      this.quantityInput = input;

      if (!this.quantityInput) return;
      this.quantityInput.addEventListener('change', this.onQuantityChange);
      this.quantityInput.addEventListener('input', this.onQuantityChange);
    }

    unbindQuantityInput() {
      if (!this.quantityInput) return;
      this.quantityInput.removeEventListener('change', this.onQuantityChange);
      this.quantityInput.removeEventListener('input', this.onQuantityChange);
      this.quantityInput = null;
    }

    get quantity() {
      const value = parseInt(this.quantityInput?.value, 10);
      return Number.isNaN(value) || value < 1 ? 1 : value;
    }

    render() {
      const quantity = this.quantity;

      this.querySelectorAll('[data-unit-price]').forEach((element) => {
        const unitPrice = parseInt(element.dataset.unitPrice, 10);
        if (Number.isNaN(unitPrice)) return;

        element.textContent = this.formatMoney(unitPrice * quantity);
      });
    }

    formatMoney(cents) {
      const format = window.Theme?.formatMoney;
      return format ? format(cents, this.dataset.moneyFormat) : (cents / 100).toFixed(2);
    }
  }

  customElements.define('product-submit-price', ProductSubmitPrice);
}
